import { Component, Prop, Vue } from 'vue-property-decorator';

import { InitialSource } from './interfaces';

@Component
export default class Avatar extends Vue {
    @Prop()
    logo: string;

    @Prop({ default: '128px' })
    size: string;

    @Prop([Array, String])
    content: Array<string> | string;

    @Prop({ default: '(^|\\s+)(\\w|[\u0300-\u04ff]|[\u0530-\u074F])' })
    pattern: string;

    @Prop({
        type: [Array, String],
        default: 'ltr'
    })
    direction: Array<string> | string;

    @Prop({ default: 2 })
    characters: number;

    patternRegex: RegExp;

    created() {
        this.patternRegex = new RegExp(this.pattern, 'gu');
    }

    getDirection(index: number = 0) {
        if (typeof this.direction === 'string') {
            return this.direction;
        }

        return this.direction[index] ? this.direction[index] : this.direction[0];
    }

    slice(content, characters, direction = 'ltr') {
        if (direction === 'rtl') {
            return content.slice(-characters);
        }

        return content.slice(0, characters);
    }

    applyPattern(content, direction, characters) {
        const matches = content.match(this.patternRegex);

        if (!matches) {
            return '';
        }

        return matches.length > 1
            ? this.slice(matches.join('').replace(/\s/g, ''), characters, direction)
            : this.slice(content, characters);
    }

    get cssStyle() {
        return `width:${this.size};height:${this.size};font-size:calc(${this.size}/2)`;
    }

    get fullName(): Array<string> {
        return typeof this.content === 'string' ? [this.content] : this.content;
    }

    get initials(): string {
        if (!this.content) {
            return '';
        }

        if (typeof this.content === 'string') {
            return this.applyPattern(this.content, this.getDirection(), this.characters);
        }

        const initialSources : Array<InitialSource> = this.content.map((item, index) => ({
            content: (item || '').trim(),
            direction: this.getDirection(index)
        })).filter((initialSource) => initialSource.content.length > 0);

        if (!initialSources) {
            return '';
        }

        let initials = initialSources.map((initialSource) => this.applyPattern(initialSource.content, initialSource.direction, 1)).join('');

        const remainCharacters = this.characters - initials.length;

        if (remainCharacters > 0) {
            const additions = initialSources.slice(-1);

            if (additions.length > 0) {
                const initialSource = additions[0];

                initials = initials.slice(0, -1)
                    + this.applyPattern(initialSource.content, initialSource.direction, remainCharacters + 1);
            }
        }

        return initials;
    }
}
